// resume initial state - update if resumeTypes.ts changes

import { ResumeContent } from "./resumeTypes";

export const resumeInitialState: ResumeContent = {
  fullName: "",
  email: "",
  phoneNumber: "",
  city: "",
  countryCode: "",
  jobTitle: "",
  linkedinUrl: "",
  portfolioUrl: "",
  yearsExperience: 0,

  education: [],
  workExperience: [],
  certifications: [],
  languages: [],
  referees: [],

  softSkills: [],
  technicalSkills: [],

  summaryStyle: {
    careerFocus: "",
    personality: "",
    industryTone: "",
    experienceLevel: "",
  },
};
